import './login.scss'

/* React */
import { useState, useCallback } from 'react'

/* Bootstrap */
import Card from 'react-bootstrap/Card'

/* Types */
import { activeUser } from 'src/types/user'
import { isApiResponse } from 'src/types/response'
import { isLoginResponse } from 'src/shared/apiBackendResponses/login'

/* Context */
import { useContext } from 'react'
import ApiContext from 'src/ApiContext'
import { AppContext } from 'src/AppContext'
import config from 'src/config'

/* Components */
import Container from 'src/components/Container/Container'
import getForm, { tInput } from 'src/components/Form/Form'


const Login: React.FC = () => {
  const api = useContext(ApiContext)
  const { appDispatch } = useContext(AppContext)

  const [ error, setError ] = useState(null as null | string)

  const localToken = localStorage.getItem('Token')
  const localComputer = localStorage.getItem('Computer')

  const initialState = {
    name: '',
    password: '',
    token: localToken || '',
    computer: localComputer || '',
  }

  type form = typeof initialState
  type keys = keyof form

  const inputs: tInput<keys>[] = [
    {
      name: 'name',
      placeholder: 'Benutzername',
      minLength: 3,
    },{
      name: 'password',
      placeholder: 'Passwort',
      type: 'password',
      minLength: 8,
    },{
      name: 'token',
      placeholder: 'Token',
      minLength: 4,
    },{
      name: 'computer',
      placeholder: 'Computername',
      minLength: 4,
    },
  ]

  const tryLogin = useCallback(async (values:form) => {
    const { name, token, computer } = values

    const resUser = await new Promise<unknown>(resolve => {
      api.socket.emit('login', values, (res: unknown) => {
        resolve(res)
      })
    })

    if (
      !isApiResponse(resUser)
      || !isLoginResponse(resUser.response)
      || resUser.response === false
    ) {
      setError("Login fehlgeschlagen")
      return
    }

    const activeUser: activeUser = {
      name, computer,
      token: resUser.response.token,
      rights: resUser.response.rights,
    }

    localStorage.setItem('User', JSON.stringify(activeUser))
    localStorage.setItem('Token', token)
    localStorage.setItem('Computer', computer)

    appDispatch({type: 'LOGIN', payload: activeUser})

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Form = getForm<form,keys>({
    initialState,
    inputs,
    allRequired:true,
    button:{
      text: 'Login',
    },
    onSubmit:tryLogin,
  })

  return <Container className='Route-Login' maxWidth={false}>
    <Card data-testid='Route-Login-Form'>

      <Card.Header>{config.backend_title}</Card.Header>

      <Card.Body>
        <Form />
      </Card.Body>

      {error &&
        <Card.Footer>
          <small className='text-muted'>{error}</small>
        </Card.Footer>
      }
      
    </Card>
  </Container>
}

export default Login
